import { nullable } from '@infl-ts/util-io-ts';
import { ActivityState } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
export var ChallengeSort = t.keyof({
  RECOMMENDED: null,
  NEWEST: null,
  OLDEST: null,
  MOST_POINTS: null
});
export var Activity = t.type({
  id: t.string,
  state: ActivityState,
  currentStage: nullable(t.type({
    position: t.number
  }))
});
export var Image = t.intersection([t.type({
  id: t.string,
  blurhash: t.string
}), t.partial({
  url: t.string
})]);
export var Challenge = t.type({
  __typename: t.literal('Challenge'),
  id: t.string,
  activities: nullable(t.array(Activity)),
  banner: nullable(Image),
  headline: t.string,
  description: nullable(t.string),
  category: nullable(t.type({
    id: t.string,
    name: t.string
  })),
  minimumAvailablePoints: t.number,
  maximumAvailablePoints: t.number,
  totalStages: t.number,
  unseen: t["boolean"],
  multiComplete: t["boolean"],
  expiresAt: nullable(t.string),
  inProgress: t["boolean"],
  savedForLater: t["boolean"],
  remainingCompletionCount: nullable(t.number),
  memberRemainingCompletionCount: nullable(t.number),
  availableForCompletion: t["boolean"]
});
export var ChallengeEdge = t.type({
  __typename: t.literal('ChallengeEdge'),
  node: nullable(Challenge),
  cursor: t.string
});
export var Channel = t.type({
  __typename: t.literal('Channel'),
  id: t.string,
  name: t.string,
  darkMode: t["boolean"],
  usePrimaryColorForOverlay: t["boolean"],
  availableChallengeCount: nullable(t.number),
  banner: nullable(Image),
  description: nullable(t.string),
  newChallengeCount: nullable(t.number)
});
export var ChannelEdge = t.type({
  __typename: t.literal('ChannelEdge'),
  node: nullable(Channel),
  cursor: t.string
});
export var ChallengeQueryInput = t.partial({
  channelId: t.string,
  categoryIds: t.array(t.string),
  challengesFirst: t.number,
  challengesAfter: t.string
});
export var AvailableChallengeQueryInput = t.intersection([ChallengeQueryInput, t.partial({
  sortType: ChallengeSort,
  inProgressOnly: t["boolean"],
  channelsFirst: t.number,
  channelsAfter: t.string,
  includeChannelContent: t["boolean"]
})]);
export var LaterChallengeQueryInput = t.intersection([ChallengeQueryInput, t.partial({
  inProgressOnly: t["boolean"]
})]);